import React from 'react';
import { useSelector } from 'react-redux';
import RewardPointsAndBonus from './../../presentation/rewardPointsAndBonus/RewardPointsAndBonus';
import useMyBadgeAssignments from '../../hooks/useMyBadgeAssignments';

const RewardPointsAndBonusContainer = ({
	userBadgePoints,
	userBadgeCount,
	rewardsToClaimCount,
}) => {
	const currentUser = useSelector((state) => state.user.currentUser);
	const { badgeList } = useMyBadgeAssignments(currentUser, false, () => {});

	const disableNominations =
		currentUser?.company?.recognitionSettings?.disableNominations;

	let recognitionTotals = null;
	if (badgeList && badgeList.length > 0) {
		const recognitions = badgeList.filter(
			(badge) =>
				badge.badgeType?.includes('PEERTOPEER') ||
				badge.badgeType?.includes('On-the-Spot')
		);
		const nominations = badgeList.filter((badge) =>
			badge.badgeType?.includes('NOMINATED')
		);
		const gifts = badgeList.filter(
			(badge) => badge.snappyGrantId && !badge.sentWithoutSnappyGrant
		);

		recognitionTotals = {
			recognitions: recognitions.length,
			nominations: userBadgePoints || 0,
			gifts: gifts.length,
		};
	}

	const effectivePoints = userBadgePoints || 0;

	return (
		<RewardPointsAndBonus
			rewardPointsBonus={effectivePoints}
			recognitionTotals={recognitionTotals}
			disableNominations={disableNominations}
			userBadgePoints={userBadgePoints}
			userBadgeCount={userBadgeCount}
			rewardsToClaimCount={rewardsToClaimCount}
		/>
	);
};

export default RewardPointsAndBonusContainer;
